import React, { Component } from 'react';

// shouldUpdate HOC pulled from recompose, for optimizing functional components

const shouldUpdate = testFn => BaseComponent => {
  class ShouldUpdate extends Component {
    shouldComponentUpdate(nextProps) {
      return testFn(this.props, nextProps);
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  return ShouldUpdate;
};

export default shouldUpdate;
